import { PaginationRequest } from '../config/common';
import { Time } from '@angular/common';
import { ConsignmentPackages, ConsignmentPallets, Customer, ConsignmentAddtionalDetails, Consignment } from '../../models';
import { CollectionType } from 'src/@shared/enums/collection-type';
export class PaginationConsignmentRequest extends PaginationRequest {
    customerID?: string;
    serviceConsignments?: Number; //
    date?: Date;
    time?: Time;
    premisesOpenUntil?: Time;
    customerContact?: string;
    customerEmail?: string;
    poNumber?: string;
    pickupLocation?: string;
    consignmentType?: Number;
    collectionAddressID?: string;
    collectionPostCode?: string;
    collectionAddress1?: string;
    collectionAddress2?: string;
    collectionAddress3?: string;
    collectionTown?: string;
    collectionCounty?: string;
    collectionCountry?: string;
    deliveryAddressID?: string;

    deliveryPostCode?: string;
    deliveryAddress1?: string;
    deliveryAddress2?: string;
    deliveryAddress3?: string;
    deliveryTown?: string;
    deliveryCounty?: string;
    deliveryTime?: string;
    deliveryCountry?: string;
    serviceLevelConsignment?: Number;

    vehicleTypeID?: string;
    insuranceTypes?: Number;
    tailLift?: boolean;
    specialInstructions?: string;
    goodDescription?: string;
    transportService?: Number;
    goodsValue?: Number;
    check1?: boolean;
    check2?: boolean;
    check3?: boolean;
    check4?: boolean;
    check5?: boolean;
    customerNotes?: string;
    baseCustomerPrice?: Number;
    baseCostPrice?: Number;
    statusConsignment?: Number;
    consignmentPackages?: Array<ConsignmentPackages>;
    consignmentPallets?: Array<ConsignmentPallets>;
}

export interface CreateConsignmentServiceRequest {
  customerID?: string;
  serviceConsignments?: Number;
  id?: string;
}
export interface CreateConsignmentRequest {
    customerID?: string;
    serviceConsignments?: Number;
    id?: string;
    date?: Date;
    time?: string;
    premisesOpenUntil?: string;
    customerContact?: string;
    customerEmail?: string;
    poNumber?: string;
    pickupLocation?: string;
    checkWeight?: Number;
    consignmentType?: Number;
    fromQuote?: boolean;
    quotationID?: string;
    collectionAddressID?: string;
    collectionPostCode?: string;
    collectionAddress1?: string;
    collectionAddress2?: string;
    collectionAddress3?: string;
    collectionTown?: string;
    collectionCounty?: string;
    collectionCompanyName?: string;
    collectionContactName?: string;
    collectionHouseNumber?: string;

    deliveryAddressID?: string;
    deliveryPostCode?: string;
    deliveryAddress1?: string;
    deliveryAddress2?: string;
    deliveryAddress3?: string;
    deliveryTown?: string;
    deliveryCounty?: string;
    deliveryTime?: string;
    deliveryFrom?: Date | string;
    deliveryTo?: Date | string;
    deliveryCompanyName?: string;
    deliveryContactName?: string;
    deliveryHouseNumber?: string;

    serviceLevelConsignment?: Number;
    vehicleTypeID?: string;
    insuranceTypes?: Number;
    tailLift?: boolean;
    specialInstructions?: string;
    goodDescription?: string;
    transportService?: Number;
    goodsValue?: Number;
    check1?: boolean;
    check2?: boolean;
    check3?: boolean;
    check4?: boolean;
    check5?: boolean;
    customerNotes?: string;
    baseCustomerPrice?: Number;
    baseCostPrice?: Number;
    statusConsignment?: Number;
    milesBetweenTwoPostCode?: number;
    consignmentPackages?: Array<ConsignmentPackages>;
    consignmentPallets?: Array<ConsignmentPallets>;
  subcontractorID?: string;
  subcontractorHxID?: string;

}

export class CountNewConsignmentRequest {
    dateRange: number; // (0 - All, 1 - Last 1 day or 24 hours, 30 - Last 30 days)
    groupBy: string; // (hour, status)
}
export class CountNewConsignmentDto {
    key: number;
    numberOfJobs: number;
    constructor(key: number, numberOfJobs: number) {
        this.key = key;
        this.numberOfJobs = numberOfJobs;
    }
}

export class CountOpenConsignmentRequest {
    dateRange: number; // (0 - All, 1 - Last 1 day or 24 hours, 30 - Last 30 days)
    groupBy: string; // (hour, status)
}
export class CountOpenConsignmentDto {
    key: number;
    numberOfJobs: number;
    constructor(key: number, numberOfJobs: number) {
        this.key = key;
        this.numberOfJobs = numberOfJobs;
    }
}

export class CountExceptionConsignmentRequest {
    dateRange: number; // (0 - All, 1 - Last 1 day or 24 hours, 30 - Last 30 days)
    groupBy: string; // (hour, status)
}
export class CountExceptionConsignmentDto {
    key: number;
    numberOfJobs: number;
    constructor(key: number, numberOfJobs: number) {
        this.key = key;
        this.numberOfJobs = numberOfJobs;
    }
}

export class CountDiscrepancyConsignmentRequest {
    dateRange: number; // (0 - All, 1 - Last 1 day or 24 hours, 30 - Last 30 days)
    groupBy: string; // (hour, status)
}
export class CountDiscrepancyConsignmentDto {
    key: number;
    numberOfJobs: number;
    constructor(key: number, numberOfJobs: number) {
        this.key = key;
        this.numberOfJobs = numberOfJobs;
    }
}

export class ConsignmentRequest extends PaginationRequest {
    dateRange: number = 0;
    customerId: string;
    subcontractorId?: string;
    dateFrom: Date;
    dateTo: Date;
    collectionType?: CollectionType;
}

export class CustomerConsignmentModel {
    Id: number;
    CompanyName: string;
    AccountsAddress1: string;
    AccountsTownCity: string;
    AccountsCounty: string;
    AccountsPostcode: string;
    Consignments: Array<any>;
}

export class PrintConsignmentModel {
    fromDate: Date;
    toDate: Date;
    consignments: Array<Consignment>;
    customerId?: string;
}

export class PrintAllDriveConsignmentModel {
    subcontratorName : string;
    consignments: Array<Consignment>;
}

export interface PrintLabelSupplierModel {
    fromDate?: Date;
    toDate?: Date;
    suppliers: Array<LableModelSupplier>;
}

export interface LableModelSupplier {
    accountCode: string;
    consignmentIDNumber: string;
    consignmentReference: string;
    totalWeight: number;
    deliveryCompanyName: string;
    deliveryAddress1: string;
    deliveryAddress2: string | null;
    deliveryAddress3: string | null;
    deliveryTown: string | null;
    deliveryPostCode: string;
    deliveryTel: string;

    collectionCompanyName: string;
    collectionAddress: string;
    collectionPostCode: string;
    collectionTel: string;

    serviceLevelConsignments: number;
    carton: string;
    cartonReference: string;
    specialInstructions: string;

    consignmentService: number;
    customerCompanyName: string;
    cartonDx: string;
    date: Date;
    consignmentNoOfItems: string;
    depot: string | null;
    hubZone: string | null;
    externalId: string | null;

    barCode: string;
    barCodeSrc: string;
}
